import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RespuestaComun } from 'src/app/modal/maestras/respuesta-comun';
import { MaestrasService } from 'src/app/service/maestras/maestras.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import {UsuarioRegistroRequest} from 'src/app/modal/usuario/usuario-registro-request';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registrar',
  templateUrl: './registrar.component.html',
  styleUrls: ['./registrar.component.scss']
})
export class RegistrarComponent implements OnInit {
  registrarForm: FormGroup;
  listTipoDocumento:RespuestaComun;
  registrarRequest:UsuarioRegistroRequest;
  maxLengthTxtNroDocumento:number=15; // Valor por defecto (máximo permitido)
  acceptAdditionalDataTreatment: boolean = false;
  //@ViewChild(LoginComponent) loginComponent:LoginComponent;

  constructor(private routerLink:Router,private fb: FormBuilder,private maestraService:MaestrasService,private utilService:UtilitarioService,private usuarioService:UsuarioService) { 
  this.createForm();
  }


  createForm(){
    this.registrarForm = this.fb.group({

      txtCorreo:['', [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      txtNombre:['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/)]],
      txtApellidos:['', [Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/)]],
      txtTipoDocumento:['',Validators.required],
      txtNroDocumento:['',Validators.required],
      txtFechaNacimiento:['',Validators.required],
      txtTelefono:['', [Validators.required, Validators.minLength(7), Validators.maxLength(15), Validators.pattern(/^[0-9+\-\s()]+$/)]],
      txtPassword:['', [Validators.required, Validators.minLength(6)]],
      txtPassword2:['', [Validators.required, Validators.minLength(6)]],

    });
  }
  displayFieldCss(field: string) {
    if (this.registrarForm.get(field).touched){
      return {
        'is-invalid': this.isFieldValid(field),
        'is-valid': !this.isFieldValid(field)
      };      
    }
  }

  tipoDeDocumento(){
    this.listTipoDocumento = new RespuestaComun();
    this.maestraService.obtenerMaestra("TIPO_DOCUMENTO").subscribe(data=>{
      this.listTipoDocumento = data;
      // console.log(data);
    })
  }

  onChangeTipoDoc(codigo:String){
    const docControl = this.registrarForm.get('txtNroDocumento');

    switch (codigo) {
      case "1": // DNI Perú
        this.maxLengthTxtNroDocumento = 8;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
          Validators.pattern(/^[0-9]{8}$/)
        ]);
        break;
      case "2": // Carnet de Extranjería
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]);
        break;
      case "3": // Pasaporte
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]);
        break;
      case "4": // Otro documento
        this.maxLengthTxtNroDocumento = 15;
        docControl.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(15),
          Validators.pattern(/^[a-zA-Z0-9\-]+$/)
        ]);
        break;
      default:
        docControl.setValidators([Validators.required]);
        break;
    }

    // Actualizar la validación del control
    docControl.updateValueAndValidity();
    (<HTMLInputElement>document.getElementById("txtNroDocumento")).value = "";
  }
  
  valirdarPass(){
    let retorno = true;
    let pass1 = this.registrarForm.get("txtPassword").value;
    let pass2 = this.registrarForm.get("txtPassword2").value;
    if(pass1===pass2){
      retorno = false;
    }
    return retorno;
  }

  fc_ValTextDocumento(event: any) {
    const inputChar = String.fromCharCode(event.charCode);
    const tipoDoc = this.registrarForm.get("txtTipoDocumento").value;

    // Permitir teclas de control (Enter, Backspace, etc.)
    if (event.charCode === 0) {
      return true;
    }

    switch (tipoDoc) {
      case "1": // DNI - solo números
        const dniPattern = /[0-9]/;
        if (!dniPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      case "2": // Carnet de Extranjería - letras y números
      case "3": // Pasaporte - letras y números
        const alfanumPattern = /[a-zA-Z0-9]/;
        if (!alfanumPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      case "4": // Otro - letras, números y guión
        const otroPattern = /[a-zA-Z0-9\-]/;
        if (!otroPattern.test(inputChar)) {
          event.preventDefault();
          return false;
        }
        break;

      default:
        return true;
    }

    return true;
  }

  formatearFecha(fecha){
    let fechaNac:string="";
    if(fecha!=null){
      var date = new Date(fecha+"T05:00:00Z");
      ////console.log(date);
      var day = date.getDate();
      var month = date.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12
      var year = date.getFullYear();
      fechaNac = day+"/"+month+"/"+year;
    //console.log(fechaNac);
    }
    return fechaNac
  }
  registrar(){  
    if (this.registrarForm.valid) {
      this.utilService.loading=true;
      if(this.valirdarPass()){
        
        this.utilService.toastrError("Contraseñas Incorrectas");
        this.utilService.loading=false;
        return false;
      }
      
      this.registrarRequest = new UsuarioRegistroRequest();
      this.registrarRequest.birthDate = this.formatearFecha(this.registrarForm.get("txtFechaNacimiento").value);
      this.registrarRequest.email = this.registrarForm.get("txtCorreo").value;
      this.registrarRequest.name = this.registrarForm.get("txtNombre").value;
      this.registrarRequest.surname = this.registrarForm.get("txtApellidos").value;
      this.registrarRequest.typeDocument = this.registrarForm.get("txtTipoDocumento").value;
      this.registrarRequest.telephone = this.registrarForm.get("txtTelefono").value;
      this.registrarRequest.password = this.registrarForm.get("txtPassword").value;
      this.registrarRequest.document = this.registrarForm.get("txtNroDocumento").value;
      this.registrarRequest.acceptAdditionalDataTreatment = this.acceptAdditionalDataTreatment ? '1' : '0';

      if((this.registrarRequest.document.length > 8 ||  this.registrarRequest.document.length < 8) && this.registrarRequest.typeDocument=='1'){
        this.utilService.toastrError("El número de DNI debe ser de 8 dígitos");
        this.utilService.loading=false;
        return false;
      }

      if((this.registrarRequest.document.length > 15) && this.registrarRequest.typeDocument=='2'){
        this.utilService.toastrError("El número de Carnet de Extranjeria no puede ser mayor a 15 dígitos");
        this.utilService.loading=false;
        return false;
      }

      if((this.registrarRequest.document.length > 15) && this.registrarRequest.typeDocument=='3'){
        this.utilService.toastrError("El número de Pasaporte no puede ser mayor a 15 dígitos");
        this.utilService.loading=false;
        return false;
      }

      //console.log(this.registrarRequest);
      this.usuarioService.registrarUsuario(this.registrarRequest).subscribe(data=>{
        // console.log(data);
        if(data.response.codeResponse==="0000"){
          this.utilService.toastrSuccess(data.response.response);
          this.routerLink.navigate(['/']);
          // let credenciales:UsuarioRequest;
          // credenciales = new UsuarioRequest();
          // credenciales.email=this.registrarRequest.email;
          // credenciales.password=this.registrarRequest.password;
          // this.usuarioService.loginUser(credenciales).subscribe(data=>{
          //     this.utilService.toastrSuccess("Bienvenido "+data.response.list[0].name)
          //     this.loginComponent.flagLogin=true;
          //     this.routerLink.navigate(['/']);
          //   });
        }
        else{
          this.utilService.toastrError(data.response.response);
        }
        this.utilService.loading=false;
      })
    }
    else{
      this.validateAllFormFields(this.registrarForm);
      this.utilService.toastrError("Rellene los campos obligatorios");
    }

  }
  isFieldValid(field: string) {
    return !this.registrarForm.get(field).valid && this.registrarForm.get(field).touched;
  }

  validarCampo(campo: string) {
    const control = this.registrarForm.get(campo);

    if (!control || control.valid) {
      return;
    }

    const errores = control.errors;

    // Validar campo txtNombre
    if (campo === 'txtNombre' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El nombre es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('El nombre solo puede contener letras');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El nombre debe tener al menos 2 caracteres');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El nombre no puede exceder 50 caracteres');
      }
    }

    // Validar campo txtApellidos
    if (campo === 'txtApellidos' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Los apellidos son requeridos');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('Los apellidos solo pueden contener letras');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('Los apellidos deben tener al menos 2 caracteres');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('Los apellidos no pueden exceder 50 caracteres');
      }
    }

    // Validar campo txtCorreo
    if (campo === 'txtCorreo' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El correo es requerido');
      } else if (errores.email || errores.pattern) {
        this.utilService.toastrWarning('Ingrese un correo válido');
      }
    }

    // Validar campo txtTipoDocumento
    if (campo === 'txtTipoDocumento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('Debe seleccionar un tipo de documento');
      }
    }

    // Validar campo txtNroDocumento
    if (campo === 'txtNroDocumento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El número de documento es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('Formato de documento inválido');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El documento es muy corto');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El documento es muy largo');
      }
    }

    // Validar campo txtTelefono
    if (campo === 'txtTelefono' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('El teléfono es requerido');
      } else if (errores.pattern) {
        this.utilService.toastrWarning('El teléfono solo puede contener números y los símbolos + - ( )');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('El teléfono debe tener al menos 7 dígitos');
      } else if (errores.maxlength) {
        this.utilService.toastrWarning('El teléfono no puede exceder 15 dígitos');
      }
    }

    // Validar campo txtFechaNacimiento
    if (campo === 'txtFechaNacimiento' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('La fecha de nacimiento es requerida');
      }
    }

    // Validar campo txtPassword
    if (campo === 'txtPassword' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('La contraseña es requerida');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('La contraseña debe tener al menos 6 caracteres');
      }
    }

    // Validar campo txtPassword2
    if (campo === 'txtPassword2' && errores) {
      if (errores.required) {
        this.utilService.toastrWarning('La confirmación de contraseña es requerida');
      } else if (errores.minlength) {
        this.utilService.toastrWarning('La confirmación debe tener al menos 6 caracteres');
      }
    }
  }   

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  verificarSession(){
    if(this.usuarioService.existeSesionUsuario()){
      this.routerLink.navigate(['/']);
    }
  }
  ngOnInit(): void {
    this.tipoDeDocumento();
    this.verificarSession();
  }

  onClickTratamientoDatos(){
    window.open('https://www.editoraperu.com.pe/PrivacidadEP/Politica_Proteccion_Datos_Personales.pdf', '_blank');
  }
}
